<template>
  <div>
    <general-availability
      v-if="showGeneralAvailability"
      :schedule="schedule"
      :sitterName="sitterName"
      :availabilityValidUntil="availabilityValidUntil"
      :careType="careType"
      :editModeActive="editModeActive"
      class="border-t-1 border-solid border-grey-divider-subdued pt-16"
    />
    <availability-calendar
      :accountId="sitterId"
      :editModeActive="editModeActive"
      alwaysMobileVariant
      :class="hasCalendarAvailability ? 'border-t-1 border-solid border-grey-divider-subdued pt-16 mt-16' : ''"
      @update-calendar-availability="updateCalendarAvailability"
    />
  </div>
</template>

<script lang="ts">
import GeneralAvailability from '@/components/general_availability/GeneralAvailability.vue';
import AvailabilityCalendar from '@/components/calendar/AvailabilityCalendar.vue';

export default {
  name: 'ProfileSchedule',
  components: {
    GeneralAvailability,
    AvailabilityCalendar,
  },
  props: {
    schedule: {
      type: Array,
      default: () => [],
    },
    sitterName: {
      type: String,
      default: 'the sitter',
    },
    sitterId: {
      type: String,
      default: '',
    },
    availabilityValidUntil: {
      type: String || null,
      default: null,
    },
    careType: {
      type: String,
      default: '',
    },
    editModeActive: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      hasCalendarAvailability: false,
    };
  },
  computed: {
    showGeneralAvailability(): boolean {
      return this.schedule.length > 0 || this.editModeActive || !this.hasCalendarAvailability;
    },
  },
  methods: {
    updateCalendarAvailability(val) {
      this.hasCalendarAvailability = val;
      this.$emit('update-calendar-availability', val);
    },
  },
};
</script>
